(function ClientMassMarketing($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload('/Clients/add/', function onload()
		{
			// check radio button selection
			var add_type = $('[name="form_component_data[ClientAdd][add_type]"]');

			add_type.on('change', function checkType(e)
			{
				var type_val = $(this).closest("div.radio-group").find("label.active").children().val();

				if (type_val === "household") {
					document.location = Adzuki.base_uri + "/Households/add";
				} else if (type_val === "client") {
					$(".add-form-container").removeClass('hidden');
					$(".save-changes").removeClass('hidden');
				}
			});
		});

		Adzuki.onload('/Clients/view/', function onload()
		{
			var modal_title = $(".modal-title"),
				modal_body  = $(".modal-body"),
				$modal      = $(".modal"),
				popup_title = $('#popup_comment').data("modal-title"),
				popup_body  = $('#popup_comment').data("modal-body");

			if ($('#popup_comment').length) {

				$modal.addClass('wide');
				$modal.find('.modal-body').html(popup_body);
				$modal.find('.modal-title').text(popup_title);

				$modal.modal('show');
			}

			$(".view-sample-email").on('click', function showSampleEmail(e)
			{
				var url  = '/Clients/viewSampleEmail';

				e.preventDefault();

				Adzuki.Ajax.get(url).then(function success(response) {
					modal_title.html(response.subject);
					modal_body.html(response.body);
				});
			});

			$('.copy-to-clipboard').click(function copyToClipboard(e)
			{
				var content = $(this).data('content'),
				$temp;
				e.preventDefault();

				if (content.length === 0) {
					Adzuki.StatusMessage('Error', 'Please make sure that there is content to copy.');
				} else {
					$temp = $("<textarea>");
					$(this).append($temp);

					$temp.val(content).select();
					document.execCommand("copy");
					$temp.remove();

					Adzuki.StatusMessage('Success', 'The content has been copied to your clipboard.');
				}
			});
		});

		Adzuki.onload('/Clients/chat/', function onload()
		{
			// nothing to put here yet
		});

		Adzuki.onload('/Clients/comments/', function onload()
		{
			// Adzuki.Form.initAjaxForm('ClientCommunication');
			// for displaying client comment
			$('.comment').click(function showComment(e) {
				var $self         = $(this),
					$modal        = $(".modal"),
					comment_id    = $self.data("comment-id"),
					modal_title   = $self.data("modal-title");

				e.preventDefault();

				$modal.addClass('wide');
				$modal.find('.modal-body').text('Loading comment...');

				Adzuki.Ajax.get('/ClientComments/view/' + comment_id)
					.then(function _showComment(html) {
						$modal.find('.modal-body').html(html);
						$modal.find('[data-toggle^="tooltip"]').tooltip();
				});

				$modal.find('.modal-title').text(modal_title);
				$modal.on('hidden.bs.modal', function _restoreModal() {
					$modal.removeClass('wide').off('hidden.bs.modal');
				}).modal('show');
			});

			// for displaying client communication log
			$('.communication').click(function showCommunication(e) {
				var $self            = $(this),
					$modal           = $(".modal"),
					communication_id = $self.data("communication-id"),
					modal_title      = $self.data("modal-title");

				e.preventDefault();

				$modal.addClass('wide');
				$modal.find('.modal-body').text('Loading communication log...</i>');

				Adzuki.Ajax.get('/ClientCommunications/view/' + communication_id)
					.then(function _showCommunication(html) {
						$modal.find('.modal-body').html(html);
						$modal.find('[data-toggle^="tooltip"]').tooltip();
				});

				$modal.find('.modal-title').text(modal_title);
				$modal.on('hidden.bs.modal', function _restoreModal() {
					$modal.removeClass('wide').off('hidden.bs.modal');
				}).modal('show');
			});
		});

		Adzuki.onload('/Clients/exportClients/', function onload()
		{
			var custom_export_form   = $(".custom-export-form"),
				custom_export_fields = custom_export_form.find('.client-fields input'),
				export_template_form = $(".export-template-form");

			// CUSTOM EXPORT
			custom_export_form.on('click', '.checkall', function checkAllFields(e)
			{
				e.preventDefault();

				custom_export_fields.each(function checkField(e)
				{
					var field = $(this);
					field.attr("checked", "checked");
				});
			});

			custom_export_form.on('click', '.uncheckall', function unCheckAllFields(e)
			{
				e.preventDefault();

				custom_export_fields.each(function uncheckField(e)
				{
					var field = $(this);
					field.removeAttr("checked");
				});
			});

			custom_export_form.on('change', '.filter-clients', function checkVal(e)
			{
				var val = $(this).val();
				if (val === "by_segment") {
					custom_export_form.find(".segments-list").removeClass("hidden");
				} else {
					custom_export_form.find(".segments-list").addClass("hidden");
				} // if (val === "by_segment")
			});

			export_template_form.on('change', '.filter-clients', function checkVal(e)
			{
				var val = $(this).val();
				if (val === "by_segment") {
					export_template_form.find(".segments-list").removeClass("hidden");
				} else {
					export_template_form.find(".segments-list").addClass("hidden");
				} // if (val === "by_segment")
			});

			// pre-check all checbox
			custom_export_fields.each(function precheckField(e)
			{
				var field = $(this);
				field.attr("checked", "checked");
			});
		});

		Adzuki.onload('/Clients/testimonials/', function onload()
		{
			// for displaying client testimonial
			$('.testimonial').click(function showTestimonial(e) {
				var $self             = $(this),
				    $modal            = $(".modal"),
				    modal_title       = $self.data("modal-title"),
				    testimonial_title = $self.data("testimonial-title"),
				    testimonial       = $self.data("testimonial");

				e.preventDefault();

				$modal.addClass('wide');
				$modal.find('.modal-title').text(modal_title);
				$modal.find('.modal-body').text('Loading testimonial...');
				$modal.find('.modal-body').html("<strong>TITLE</strong><br>" + testimonial_title + "<br><br><strong>TESTIMONIAL</strong><br>" + testimonial);

				$modal.on('hidden.bs.modal', function _restoreModal() {
					$modal.removeClass('wide').off('hidden.bs.modal');
				}).modal('show');
			});
		});

		Adzuki.onload(['/Clients/touchpoints/', '/Clients/timeline/'], function onload()
		{
			var modal_title = $(".modal-title"),
				modal_body  = $(".modal-body");

			var cp_pod_list_container   = $(".cp-pod-lists"),
				cp_pod_orders_container = $(".cp-pod-orders"),
				client_id               = $("#client_id").val(),
				cp_pod_lists_url        = '/Clients/_getCpPodLists/' + client_id,
				cp_pod_orders_url       = '/Clients/_getCpPodOrders/' + client_id;

			$(".arc-comparison-link").on('click', function loadArcComparison(e)
			{
				var href                  = $(this),
					arc_comparison_id  = href.data('arc-comparison-id'),
					arc_comparison_url = '/Clients/_getArcComparison/' + arc_comparison_id,
					comparison_title   = href.data('title'),
					comparison_iframe  = "<iframe src='" + Adzuki.erez_url + Adzuki.base_uri + arc_comparison_url +"' height='500' width='100%' frameborder='0'></iframe>";

				e.preventDefault();

				modal_title.html(comparison_title);
				modal_body.html(comparison_iframe);

				// Adzuki.Ajax.get(arc_comparison_url).then(function success(response) {
				// 	modal_title.html(response.subject);
				// 	modal_body.html(response.body);
				// 	// $(".modal-dialog").attr('style', 'width:900px;');
				// 	//
				// 	// ^^ commenting this out for now just in case natalia opens up a bug about the overflow
				// });
			});

			$(".cruise-comparison-link").on('click', function loadCruiseComparison(e)
			{
				var href                  = $(this),
					cruise_comparison_id  = href.data('cruise-comparison-id'),
					cruise_comparison_url = '/Clients/_getCruiseComparison/' + cruise_comparison_id,
					comparison_title   = href.data('title'),
					comparison_iframe  = "<iframe src='" + Adzuki.erez_url + Adzuki.base_uri + cruise_comparison_url +"' height='500' width='100%' frameborder='0'></iframe>";

				e.preventDefault();

				modal_title.html(comparison_title);
				modal_body.html(comparison_iframe);

				// Adzuki.Ajax.get(cruise_comparison_url).then(function success(response) {
				// 	modal_title.html(response.subject);
				// 	modal_body.html(response.body);
				// 	// $(".modal-dialog").attr('style', 'width:900px;');
				// 	//
				// 	// ^^ commenting this out for now just in case natalia opens up a bug about the overflow
				// });
			});

			$(".property-comparison-link").on('click', function loadHotelComparison(e)
			{
				var href                  = $(this),
					property_comparison_id  = href.data('property-comparison-id'),
					property_comparison_url = '/Clients/_getPropertyComparison/' + property_comparison_id,
					comparison_title        = href.data('title'),
					comparison_iframe       = "<iframe src='" + Adzuki.erez_url + Adzuki.base_uri + property_comparison_url +"' height='500' width='100%' frameborder='0'></iframe>";

				e.preventDefault();

				$('.modal').addClass('wide');

				modal_title.html(comparison_title);
				modal_body.html(comparison_iframe);
			});

			$(".hotel-comparison-link").on('click', function loadHotelComparison(e)
			{
				var href                  = $(this),
					hotel_comparison_id   = href.data('hotel-comparison-id'),
					hotel_comparison_url  = '/Clients/_getHotelComparison/' + hotel_comparison_id,
					comparison_title      = href.data('title'),
					comparison_iframe     = "<iframe src='" + Adzuki.erez_url + Adzuki.base_uri + hotel_comparison_url +"' height='500' width='100%' frameborder='0'></iframe>";

				e.preventDefault();

				$('.modal').addClass('wide');

				modal_title.html(comparison_title);
				modal_body.html(comparison_iframe);
			});

			$(".tour-comparison-link").on('click', function loadArcComparison(e)
			{
				var href                  = $(this),
					tour_comparison_id  = href.data('tour-comparison-id'),
					tour_comparison_url = '/Clients/_getTourComparison/' + tour_comparison_id,
					comparison_title   = href.data('title'),
					comparison_iframe  = "<iframe src='" + Adzuki.erez_url + Adzuki.base_uri + tour_comparison_url +"' height='500' width='100%' frameborder='0'></iframe>";

				e.preventDefault();

				modal_title.html(comparison_title);
				modal_body.html(comparison_iframe);

				// Adzuki.Ajax.get(tour_comparison_url).then(function success(response) {
				// 	modal_title.html(response.subject);
				// 	modal_body.html(response.body);
				// 	// $(".modal-dialog").attr('style', 'width:900px;');
				// 	//
				// 	// ^^ commenting this out for now just in case natalia opens up a bug about the overflow
				// });
			});

			$(".trips-shared-link").on('click', function loadTripShared(e)
			{
				var href            = $(this),
					trip_shared_id  = href.data('share-trips-id'),
					trip_shared_url = '/Clients/_getSharedTrip/' + trip_shared_id;

				e.preventDefault();

				Adzuki.Ajax.get(trip_shared_url).then(function success(response) {
					modal_title.html(response.subject);
					modal_body.html(response.body);
				});
			});

			$(".view-digital-brochure-email").on('click', function loadBrochureEmail(e)
			{
				var href         = $(this),
					brochure_id  = href.data('brochure-id'),
					brochure_url = '/Clients/viewDigitalBrochureEmail/' + brochure_id;

				e.preventDefault();

				Adzuki.Ajax.get(brochure_url).then(function success(response) {
					modal_title.html(response.subject);
					modal_body.html(response.body);
				});
			});

			$('.view-ecard-model').click(function onViewEcardClick(e)
			{
				var href      = $(this);
				var model_id  = href.data('model-id');
				var ecard_url = '/Ecards/view/' + model_id;

				e.preventDefault();

				Adzuki.Ajax.get(ecard_url).then(function success(response)
				{
					$('#modalWindow').modal();

					modal_title.html('View eCard');
					modal_body.html(response);
				});
			});

			$('.eb-view-email').click(function onViewEmailClick(e) {
				var email_builder_id = $(this).data('model-id');

				e.preventDefault();

				Adzuki.Ajax.get('/EmailBuilders/view/' + email_builder_id)
				.then(function success(response)
				{
					$('#modalWindow').modal();

					modal_title.html('View Email');
					modal_body.html(response);
				});
			});

			// view a bucket from client touchpoints
			$('.view-client-bucket').click(function onViewBucket(e)
			{
				var $self     = $(this),
					bucket_id = $self.data('bucket-id');

				e.preventDefault();

				Adzuki.Buckets.openBuckets(bucket_id);
			});

			// load cppod lists
			if (cp_pod_list_container.length === 1) {
				Adzuki.Ajax.get(cp_pod_lists_url).then(function success(response) {
					cp_pod_list_container.html(response);
					$('.delete-from-cppod').on('click', deleteClientFromList);
				});
			}

			if (cp_pod_orders_container.length === 1) {
				Adzuki.Ajax.get(cp_pod_orders_url).then(function success(response) {
					cp_pod_orders_container.html(response);
				});
			}

			$('.video').click(function showVideo(e) {
				var $self          = $(this),
					$modal         = $(".modal"),
					title          = $self.data("title"),
					iframe_src     = $self.data("iframe-src"),
					iframe_height  = $self.data("iframe-height") || 500,
					iframe_width   = $self.data("iframe-width") || '100%';

				e.preventDefault();

				$modal.addClass('wide');

				$modal.find('iframe').attr({
					src   : iframe_src,
					height: iframe_height,
					width : iframe_width
				});

				$modal.find('.modal-title').text(title);
				$modal.on('hidden.bs.modal', function _restoreModal() {
					$modal.removeClass('wide').off('hidden.bs.modal');
				}).modal('show');
			});

			// timeline view email
			$('.email-view-button').click(function showEmailMessage(e) {
				var notification_id = $(this).data('notification-id'),
					modal           = $('.modal');

				e.preventDefault();

				modal.find('.modal-body').html('<iframe src="' + Adzuki.base_uri + '/CpcentralNotifications/message/' + notification_id + '" style="border:none; width: 100%; height: 500px;"></iframe>');
				modal.find('.modal-title').text('Message Details');
				modal.on('hidden.bs.modal', function _restoreModal() {
					modal.removeClass('wide').off('hidden.bs.modal');
				}).modal('show');
			});

			// client email view
			$('.sent-email').click(function showEmail(e) {
				var $self          = $(this),
					$modal         = $(".modal"),
					iframe_src     = $self.data("iframe-src"),
					iframe_height  = $self.data("iframe-height") || 500,
					iframe_width   = $self.data("iframe-width") || '100%';

				e.preventDefault();

				$modal.addClass('wide');

				$modal.find('.modal-body').html('<iframe frameborder="0"></iframe>');

				$modal.find('iframe').attr({
					src   : iframe_src,
					height: iframe_height,
					width : iframe_width
				});

				$modal.find('.modal-title').text('');
				$modal.on('hidden.bs.modal', function _restoreModal() {
					$modal.removeClass('wide').off('hidden.bs.modal');
				}).modal('show');
			});
		});

		/* edit methods */
		Adzuki.onload('/Clients/edit/', function onload()
		{
			clientFormCreateSource();
		});

		Adzuki.onload('/Clients/editBookingInfo/', function onload()
		{
			$(".toggle-airport-name").on('click', function showTypeAHeadForm(e)
			{
				var editbtn           = $(this),
					parent            = editbtn.parent(),
					airport_typeahead = parent.next(".airport-typeahead");

				e.preventDefault();
				parent.addClass("hidden");
				airport_typeahead.removeClass("hidden");

				// remove saved id
				$('[name="form_component_data[ClientBookingInfo][air_gateway]"]').val("");
			});

			$('input[name="form_component_data[ClientBookingInfo][special_needs]"]').on('change', function _toggleSection() {
				$(".form-group."+$(this).parents('.radio-group').data('section')).toggleClass('hidden');
			});

			$('.passport-on-file').on('change', function _toggleFileAttachmet() {
				if ($('.toggle-linked-file').is(':visible')) {
					$('.toggle-linked-file').addClass('hidden');
				} else {
					$('.toggle-linked-file').removeClass('hidden');
				}
			});
		});

		Adzuki.onload('/Clients/editEmergencyContact/', function onload()
		{
			$("#clientemergencycontact-emergency_contact_relationship").on('change', function toggleRelationshipOther(e)
			{
				var relationship = $(this).val();

				if (relationship === 'Other') {
					$(".emergency-contact-relationship-other").removeClass('hidden');
				} else {
					$(".emergency-contact-relationship-other").addClass('hidden');
				}
			});
		});

		Adzuki.onload('/Clients/viewEmails/', function onload()
		{
			$('.sent-email').click(function showEmail(e) {
				var $self          = $(this),
					$modal         = $(".modal"),
					iframe_src     = $self.data("iframe-src"),
					iframe_height  = $self.data("iframe-height") || 500,
					iframe_width   = $self.data("iframe-width") || '100%';

				e.preventDefault();

				$modal.addClass('wide');

				$modal.find('.modal-body').html('<iframe frameborder="0"></iframe>');

				$modal.find('iframe').attr({
					src   : iframe_src,
					height: iframe_height,
					width : iframe_width
				});

				$modal.find('.modal-title').text('');

				$modal.on('hidden.bs.modal', function _restoreModal() {
					$modal.removeClass('wide').off('hidden.bs.modal');
				}).modal('show');
			});

			$('.reservation-peek').on('click', '.reservation-details', function showReservationDetails(e)
			{
				var $modal = $('.modal');

				e.preventDefault();

				$modal.find('.modal-body').text('Loading reservation details...');
				$modal.find('.modal-title').text('Reservation Details');
				$modal.modal('show');

				Adzuki.Ajax.get('/Reservations/reservationDetailsModal/'+$(this).data('reservation-id'))
				.then(function showDetails(data) {
					$modal.find('.modal-body').html(data);
				});
			});
		});

		Adzuki.onload('/ClientCreditCards/add/', function onload()
		{
			var address_id = $("#clientcreditcard-client_address_id");

			address_id.on('change', function loadAddress(e)
			{
				var address_id = $(this).val();
				populateClientAddress(address_id);
			});
		});

		Adzuki.onload('/ClientCreditCards/edit/', function onload()
		{
			var address_id = $("#clientcreditcard-client_address_id");

			address_id.on('change', function loadAddress(e)
			{
				var address_id = $(this).val();
				populateClientAddress(address_id);
			});
		});

		Adzuki.onload([
			'/ClientLinks/add/',
			'/ClientLinks/edit/',
		], function onload()
		{
			var $container                     = $(".client-link-page"),
				$existing                      = $container.find('.existing'),
				$existing_address_copy_enabled = $existing.find('[type="checkbox"][name$="[copy_from_address]"]'),
				$existing_address_copy_value   = $existing.find('[name$="[client_address_id]"]'),
				$new                           = $container.find('.new'),
				$new_address_copy_enabled      = $new.find('[type="checkbox"][name$="[copy_from_address]"]'),
				$new_address_copy_value        = $new.find('[name$="[client_address_id]"]');

			$container.find("input[name='client_type_radio']").on('change', function checkType(e)
			{
				if (this.value === "existing") {
					$existing.removeClass("hidden");
					$new.addClass("hidden");
					$existing_address_copy_enabled.prop('checked', $new_address_copy_enabled.prop('checked'));
					$existing_address_copy_value.val($new_address_copy_value.val());
				} else {
					$existing.addClass("hidden");
					$new.removeClass("hidden");
					$new_address_copy_enabled.prop('checked', $existing_address_copy_enabled.prop('checked'));
					$new_address_copy_value.val($existing_address_copy_value.val());
				}
			});
		});

		Adzuki.onload('/Clients/editEmergencyContact/', function onload()
		{
			var form = $("form[name='ClientEmergencyContact']");

			form.on('change', '#clientemergencycontact-emergency_contact_country_id', function loadStates()
			{
				var country  = $(this).val(),
					url      = Adzuki.base_uri + '/States/getByCountryId/' + country,
					dropdown = $("#clientemergencycontact-emergency_contact_state_id");

				switch (country) {
					case "31": // canada
						Adzuki.Ajax.get(url).then(function loadProvinces(response)
						{
							var provinces = response,
								options = '';

							options = $.map(provinces, function loadValues(province, id) {
								return "<option value='" + id + "'>" + province + "</option>";
							});
							dropdown.closest(".form-group").show();
							dropdown.closest(".form-group").find("label").html("Provinces");
							dropdown.html(options);
						});
						break;
					case "183": // america
						Adzuki.Ajax.get(url).then(function loadStates(response)
						{
							var states  = response,
								options = '';

							options = $.map(states, function loadValues(state, id) {
								return "<option value='" + id + "'>" + state + "</option>";
							});
							dropdown.closest(".form-group").show();
							dropdown.closest(".form-group").find("label").html("States");
							dropdown.html(options);
						});
						break;
					default:
						dropdown.closest(".form-group").hide();
						break;
				}


			});
		});

		// manage attachments screen
		Adzuki.onload('/Clients/attachments', function onload()
		{
			$('.task-details').off().on('click', _openTaskDetails);
		});

		Adzuki.onload('/Clients/manageTasks/', function onload()
		{
			Adzuki.TaskManager.loadEntityTasks('client');
		});

		// Adzuki.onload('/ClientSpecialOccasions/add/', function onload()
		// {
		// 	var form     = $(".client-special-occasion-form"),
		// 	    occasion = form.find("#clientspecialoccasion-description");

		// 	if (occasion.val() === "Anniversary") {
		// 		occasion.addClass("disabled");
		// 	}

		// 	form.on('submit', function removeDisabledClass()
		// 	{
		// 		occasion.removeClass("disabled");
		// 	});
		// });
		// Adzuki.onload('/ClientSpecialOccasions/edit/', function onload()
		// {
		// 	var form     = $(".client-special-occasion-form"),
		// 	    occasion = form.find("#clientspecialoccasion-description");

		// 	if (occasion.val() === "Anniversary") {
		// 		occasion.addClass("disabled");
		// 	}

		// 	form.on('submit', function removeDisabledClass()
		// 	{
		// 		occasion.removeClass("disabled");
		// 	});
		// });
	});

	function _openTaskDetails(e)
	{
		var $anchor_elem = $(this);

		e.preventDefault();

		Adzuki.TaskManager.openTaskDetails($anchor_elem);
	}

	function deleteClientFromList()
	{
		var client_id = $(this).data('client-id');
		var cppod_id  = $(this).data('cppod-id');

		event.preventDefault();

		Adzuki.CustomConfirm({
			body   : 'Are you sure you wish to delete this client from the list?',
			confirm: function deleteFromList() {
				Adzuki.Ajax.post('/CppodLists/deleteClientFromList', {
					client_id: client_id,
					cppod_id : cppod_id,
				}).then(function success(response) {
					if (response.result === 'success') {
						location.reload();
					}
				});
			}
		});
	}

	function populateClientAddress(address_id)
	{
		if (address_id === 0 || address_id === '') {
			return;
		}

		let href = "/ClientAddresses/_ajaxGetAddress/" + address_id;
		let $parent       = $('.country-select').closest('.address-fields'),
			$state_dd     = $parent.find('.state-select'),
			$state_row    = $state_dd.closest('.form-group'),
			$zip_required = $parent.find('.zip-required');

		$state_dd.empty();
		$state_dd.prop("disabled", false);
		Adzuki.Ajax.get(href).then(function success(response) {
			var address = response;

			if ( (address.country_id === '183') || (address.country_id === '31') || (address.country_id === '') ) {
				$("#clientcreditcard-country_id").val(address.country_id).trigger('change');
			} else {

				$("#clientcreditcard-country_id").val(address.country_id);
				$state_dd.prop("disabled", true);
				$zip_required.addClass('hidden');

				if (address.country_id !== '') {
					$state_row.addClass('hidden');
				}

				$("#clientcreditcard-country_id").val(address.country_id).trigger('change');
			}
			$("#clientcreditcard-address1").val(address.address1);
			$("#clientcreditcard-address2").val(address.address2);
			$("#clientcreditcard-city").val(address.city);
			$("#clientcreditcard-state_id").val(Adzuki.Ajax.get('/States/getByCountryId/' + address.country_id).then(function success(response) {
				Adzuki.Address.populateState($state_dd, response, address.state_id);
			}));
			$("#clientcreditcard-zip").val(address.zip);
		});
	}

	function clientFormCreateSource()
	{
		var new_source_link       = $(".create-new-source-link"),
			view_source_list_link = $(".select-from-sources-link");

		new_source_link.on('click', function showNewSource(e)
		{
			e.preventDefault();
			$(".sources-list").toggleClass("hidden");
			$(".create-new-source").toggleClass("hidden");
			$(this).toggleClass("hidden");
			view_source_list_link.toggleClass("hidden");
		});

		view_source_list_link.on('click', function showSourcesList(e)
		{
			e.preventDefault();
			$(".create-new-source").toggleClass("hidden");
			$(".sources-list").toggleClass("hidden");
			$(this).toggleClass("hidden");
			new_source_link.toggleClass("hidden");
			$(".create-new-source").val("");
		});
	}

}(jQuery, window.Adzuki || {}));
